export default __webpack_public_path__ + "static/media/Logo.ee17f1d7.png";